/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         data: {
 *             metaSchema: {
 *                 schema: {
 *                     fields: [{
 *                             kind: "BOOLEAN",
 *                             name: "name"
 *                         }]
 *                 }
 *             }
 *         }
 *     }
 */
export interface DraftCreateRequest {
    /**
     * From [Zalando RESTful API Guidelines - models/headers-1.0.0.yaml](https://opensource.zalando.com/restful-api-guidelines/models/headers-1.0.0.yaml).
     * The **Idempotency-Key** is a free identifier created by the client to
     * identify a request. It is used by the service to identify repeated request
     * to ensure idempotent behavior by sending the same (or a similar) response
     * without executing the request a second time.
     *
     * Clients should be careful as any subsequent requests with the same key may
     * return the same response without further check. Thus, it is recommended to
     * use a UUID version 4 (random) or any other random string with enough
     * entropy to avoid collisions.
     *
     * Keys expire after 24 hours. Clients are responsible to stay within this
     * limit, if they require idempotent behavior.
     *
     * See [API Guideline Rule #181](https://opensource.zalando.com/restful-api-guidelines/#230) for further details.
     */
    idempotencyKey?: string;
    /** The annotations of the resource. */
    annotations?: Record<string, string>;
    data: Truvity.DraftCreate;
    /** The labels of the resource. */
    labels?: Record<string, string>;
}
